import { coolSkin } from "./cool";
import { football2026Skin } from "./football2026";
import { rainySkin } from "./rainy";
import { summerSkin } from "./summer";
import type { MotionSkin, SkinId } from "./types";

export const SKINS: MotionSkin[] = [coolSkin, rainySkin, summerSkin, football2026Skin];

export function getSkin(id: string): MotionSkin {
  return SKINS.find((skin) => skin.id === id) ?? coolSkin;
}

export function isSkinId(id: string): id is SkinId {
  return SKINS.some((skin) => skin.id === id);
}
